import api from '@/core/connector/api.types';

export default class UserTraceService {
  url;

  constructor() {
    this.api = api('VUE_APP_IP_GEO_LOCATION_API_URL');
  }

  get() {
    return this.api({
      method: 'get',
      url: this.url,
      params: {
        apiKey: process.env.VUE_APP_IP_GEO_LOCATION_ACCESS_KEY,
      },
    });
  }

  fetchUserAgent() {
    this.url = 'user-agent';
    return this.get();
  }

  fetchIpGeo() {
    this.url = 'ipgeo';
    return this.get();
  }
}
